import { apiUrl } from './tool'
import axios from 'axios'

const useMock = false

export function getAppointmentAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "paginate": {
          "page": "1",
          "limit": "2",
          "page_total": "49",
          "total": "98"
        },
        "data": [
          {
            "id": "19350",
            "name": "朱耕甫",
            "phone": "0905572657",
            "doctor_name": "測試診所一號",
            "item": "矯正",
            "note": "",
            "book_time": "2021-01-10 09:00",
            "is_np": "1",
            "channel": "LINE預約",
            "inviter_alias": "Dent&Co推薦",
            "create_time": "2020-12-16 23:20",
            "update_time": "2020-12-16 23:20",
            "crm_note": "",
            "completed": "0",
            "week": "",
            "time_slot": "",
            "remind_1": "您的約診已被確認，請於 2020-12-17 10:30 準時前往\n若有疑問可致電Dent&Co牙醫診所1確認：(02)89115812",
            "remind_3": [
              {
                "reason": "此時段已有預約",
                "msg": "此時段已被他人預約，請致電Dent&Co牙醫診所1選擇其他時間：(02)89115812"
              },
              {
                "reason": "治療較為複雜",
                "msg": "您的治療較為複雜，請致電Dent&Co牙醫診所1選擇其他時間：(02)89115812"
              },
              {
                "reason": "醫師有其他安排",
                "msg": "您的醫師有其他安排，請致電Dent&Co牙醫診所1選擇其他時間：(02)89115812"
              },
              {
                "reason": "不修改訊息內容",
                "msg": "您的線上預約不成功，請致電Dent&Co牙醫診所1選擇其他時間：(02)89115812"
              }
            ],
          }
        ]
      }
    })
  }
  const url = apiUrl('appointments')
  return axios.get(url, {params})
}

export function updateAppointmentAPI(id, data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('appointments', id)
  return axios.put(url, data)

  // return Promise.reject({
  //   response: {
  //     data: {
  //       fail_code: '500',
  //       messages: "不知道三小"
  //     }
  //   }
  // })
}

export function getRescheduleAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: [
        {
          "reserve_no": "2092162",
          "name": "蔡友仁",
          "doctor_name": "王醫師",
          "note": "",
          "phone": "0922099195",
          "start_time": "2021-08-25 00;55",
          "updated_time": "0000-00-00 00:00:00",
          "change_reason": "",
          "call_clinic_status": "0"
        }
      ]
    })
  }
  const url = apiUrl('change_reserves')
  return axios.get(url, {params})
}

export function updateRescheduleAPI(id, data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('change_reserves', id)
  return axios.put(url, data)
}

export function getRescheduleSettingsAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        cancellation_period: "8"
      }
    })
  }
  const url = apiUrl('change_reserves', 'settings')
  return axios.get(url, {params})
}

export function updateRescheduleSettingsAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('change_reserves', 'settings')
  return axios.put(url, data)
}

// 取得改約選項設定

// 取得改約選項設定
export function getRescheduleOptionsAPI(params) {
  const url = '/api/reschedule_options'
  return axios.get(url, { params })
}

// 更新改約選項設定（POST 批次儲存：有 id 修改、沒 id 新增、不在陣列中刪除）

// 更新改約選項設定（POST 批次儲存：有 id 修改、沒 id 新增、不在陣列中刪除）
export function updateRescheduleOptionsAPI(data) {
  const url = '/api/reschedule_options'
  return axios.post(url, data)
}

export function exportAppointmentsAPI(params) {
  // This is the real API call for the pending list
  const url = apiUrl('appointments', 'download');
  return axios.get(url, { params });
}

// Manual Appointment Notification APIs
export function getManualSendAppointmentsAPI(params) {
  const url = apiUrl('manual-send', 'appointments');
  return axios.get(url, { params });
}

export function sendManualMessagesAPI(data) {
  if (useMock) {
    console.log('Placeholder: sendManualMessagesAPI called with:', data);

    return Promise.resolve({
      data: {
        status: 'success',
        message: '訊息已進入發送佇列,預計 10 分鐘內發送完畢。(開發模式)',
      },
    });
  }
  const url = apiUrl('manual-send', 'messages');
  return axios.post(url, data);
}

